import { type Ref, ref } from "vue";
import { defineStore } from "pinia";


export const useMapStore = defineStore("map-store", () => {
  const isMapOpen: Ref<boolean> =  ref(false);


  function setIsMapOpen(isOpen: boolean){
    isMapOpen.value = isOpen
    const mapEvent = new CustomEvent<boolean>('mapEvent', { detail: isOpen });
    window.dispatchEvent(mapEvent);
  }

  return {
    isMapOpen,
    setIsMapOpen
  };
});
